import {useCallback, useState} from "react"
import {Icon} from "components/Icon"
import styles from "./AttendanceIssues.module.css"
import cx from "classnames"
import {useVisible} from "hooks"
import {AttendanceErrorLogTablePopup, AttendanceErrorLogType, AttendanceIssueItem} from "./AttendanceErrorLogTable"

export function AttendanceIssues({attendanceIssues}: {attendanceIssues: AttendanceIssueItem[]}) {
    const errorLogPopup = useVisible(false)
    const [activeType, setActiveType] = useState<AttendanceErrorLogType>()
    const [activeLabel, setActiveLabel] = useState<string>("")

    const onClosePopup = useCallback(() => {
        errorLogPopup.close()
        setActiveType(undefined)
        setActiveLabel("")
    }, [errorLogPopup])

    const onOpenErrorLog = useCallback(
        (issue: AttendanceIssueItem) => {
            if (!issue.attendanceErrorLogType) return
            setActiveType(issue.attendanceErrorLogType)
            setActiveLabel(issue.label)
            errorLogPopup.open()
        },
        [errorLogPopup]
    )

    return (
        <>
            <div className={styles.container}>
                {attendanceIssues.map((issue, index) => (
                    <div
                        key={index}
                        className={cx(styles.card, {[styles.cardWarning]: issue.count > 0})}
                        onClick={() => onOpenErrorLog(issue)}>
                        <div className={styles.iconWrap} style={{backgroundColor: issue.color + "20"}}>
                            <Icon icon={issue.icon} color={issue.color} />
                        </div>
                        <div className={styles.info}>
                            <span className={styles.count}>{issue.count}</span>
                            <span className={styles.label}>{issue.label}</span>
                        </div>
                    </div>
                ))}
            </div>
            <AttendanceErrorLogTablePopup
                isShow={errorLogPopup.isVisible}
                onClose={onClosePopup}
                activeType={activeType}
                activeLabel={activeLabel}
            />
        </>
    )
}
